var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkUploadDp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.875H13.5V18H3.375V15.75H1.125V0H8.6748L12.208 3.5332L15.75 7.0752V7.875H10.125V3.375H4.5V16.875ZM11.25 6.75H13.8252L11.25 4.1748V6.75ZM3.375 14.625V2.25H9.3252L8.2002 1.125H2.25V14.625H3.375ZM15.1875 11.0215L17.9736 13.8076L17.1826 14.5986L15.75 13.1748V18H14.625V13.1748L13.1924 14.5986L12.4014 13.8076L15.1875 11.0215ZM18 9V10.125H12.375V9H18Z",
    fill: "#009BD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUploadDp);
export default __webpack_public_path__ + "static/media/bulk-upload-dp.7430782128b9d4024388fb96a45a6d15.svg";
export { ForwardRef as ReactComponent };